import React, { useState } from "react";
import { INews } from "../../../adminPage";
import { baseUrl } from "../../../../../constants/constants";
import "./newsList.scss";
import Modal from "../../../../../components/modal/modal";
import UpdateNewsForm from "../UpdateNews/UpdateNewsForm";
import {ITags} from "../../../../public/NewsPage/news";

interface INewsList {
  news: INews;
  updateStatusNews: (cuurentNews: INews) => void;
  tags: ITags[];
  deleteNews: (currentNews: INews) => void
}

const NewsList: React.FC<INewsList> = ({ updateStatusNews, news,tags, deleteNews }) => {
    const [showUpdateNewsModal, setShowUpdateNewsModal] = useState(false)

    const closeModal = () =>{
        setShowUpdateNewsModal(false)
    }

    // const selectedTags = news.tags
    //     .map((tag) => tag.name)
    //     .join(', ') || 'Тегов нет'

    const selectedTags: React.ReactNode[] = news.tags.length > 0 ? (
        news.tags.map((tag, index) =>
            tag.name === "Новости недели" ? (
                <b key={tag.id}>{tag.name}</b>
            ) : (
                tag.name
            )
        )
    ) : ["Тегов нет"];

    const renderedTags: React.ReactNode[] = selectedTags.reduce((prev: React.ReactNode[], curr, index) => {
        if (index === selectedTags.length - 1) {
            return [...prev, curr];
        }
        return [...prev, curr, ", "];
    }, []);

    const date = new Date(news.create_date).toLocaleString('ru', {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    });

  return (
      <tr>
          <td className="applications-table__tbody-td">
              <img
                  src={`${baseUrl}${news.image_url}`}
                  alt='Картинка новости'
                  className="cards-settings__img"
              />
          </td>
          <td className="applications-table__tbody-td">{news.name}</td>
          <td className="applications-table__tbody-td">{news.description}</td>
          <td className="applications-table__tbody-td">{date}</td>
          <td className="applications-table__tbody-td_tags" >{renderedTags}</td>
          <td className="applications-table__tbody-td">
              <button
                  className='button updateBtn'
                  onClick={() => setShowUpdateNewsModal(true)}
              >
                  Обновить
              </button>
              {showUpdateNewsModal &&
                  <Modal
                      active={showUpdateNewsModal}
                      title='Обновление новости'
                      сlose={closeModal}
                  >
                      <UpdateNewsForm
                          close={closeModal}
                          news={news}
                          tags={tags}
                      />
                  </Modal>}
              <button
                  className='button archive_btn'
                  onClick={() => {
                      updateStatusNews(news);
                  }}
              >
                  Архивировать
              </button>
              <button
                  className={'button deleteBtn'}
                  onClick={() => deleteNews(news)}
              >
                  Удалить
              </button>
          </td>
      </tr>
  );
};

export default NewsList;
